import React from 'react';
import { Box } from '@mui/material';
import { getLoggedUserFullName } from 'utils';
import { getModifiedCatalogs } from 'pages/services/utils';
import { catalogs } from 'store';
import { riCatalogDialog, riSelectedCatalog } from 'pages/reference-implementation/store';
import { useRecoilState } from 'recoil';
import CustomizedDialogs from 'pages/reference-implementation/components/dialog';
import { ServicesOffered, Carousel, RecommendationsSection, BenefitsSection } from './components';
import awsComingSoon from './components/images/awsComingSoon.svg';

const LandingPageHarmonization = () => {
    const [cmpCatalogs] = useRecoilState(catalogs);
    const [catlogsData, setCatalogsData] = React.useState([]);
    const [isOpen, setIsOpen] = useRecoilState(riCatalogDialog);
    const [selectedCatalog] = useRecoilState(riSelectedCatalog);
    const fullName = getLoggedUserFullName();

    const services = catlogsData
        .filter((catalog) => catalog.isCatalogToDisplay)
        .map((catalog) => ({
            catalogDefinitionId: catalog.catalogDefinitionId,
            name: catalog.displayName,
            icon: catalog.iconPath,
            cloudProvider: catalog.cloudProvider,
            path: `${catalog.cmpUri}/${catalog.catalogDefinitionId}`,
        }));
    React.useEffect(() => {
        setCatalogsData(getModifiedCatalogs(cmpCatalogs));
    }, [cmpCatalogs]);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: '32px', gap: '16px' }} className="contentContainer">
            <Carousel carouselImage={awsComingSoon} userName={fullName} />
            <div className="services-offered-section" style={{ width: '100%' }}>
                <ServicesOffered services={services} />
            </div>
            <div className="recommendations-section" style={{ width: '100%' }}>
                <RecommendationsSection />
            </div>
            <div className="benefits-section" style={{ width: '100%' }}>
                <BenefitsSection />
            </div>

            <CustomizedDialogs
                isOpen={isOpen}
                setOpen={setIsOpen}
                rid={selectedCatalog?.['reference-implementation-id']}
                title={selectedCatalog?.name}
                provisioningPath={`${selectedCatalog?.provisioningPath}/${selectedCatalog?.['reference-implementation-id']}`}
                description={selectedCatalog?.description}
                helpUrl={selectedCatalog?.['help-link']}
                tags={selectedCatalog?.tags}
                // archImg={selectedCatalog?.archImg}
            />
        </Box>
    );
};

export default LandingPageHarmonization;
